import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import McpCorrectedLockedIcon from '@polleverywhere/assets/icons/activity-states/mcp-corrected-locked.svg'
import McpOptionsIdealIcon from '@polleverywhere/assets/icons/activity-states/mcp-options-ideal.svg'
import McpResultsIdealIcon from '@polleverywhere/assets/icons/activity-states/mcp-results-ideal.svg'
import McpResultsLockedIcon from '@polleverywhere/assets/icons/activity-states/mcp-results-locked.svg'

export default class ActivityFlow extends Backbone.Model {
  initialize (attributes = {}, options = {}) {
    this.set('name', this.get('type'))

    const allHideParams = ['instructions', 'empty_ftp_notice', 'correctness', 'clickable_image_regions', 'keywords']
    switch (this.get('type')) {
      case 'Instructor':
        this.set('steps', new Backbone.Collection([{
          summary: {
            title: 'Instructions slide',
            description: 'First, show instructions for unbiased participation.'
          },
          activity: this.get('activity'),
          icon: McpOptionsIdealIcon,
          states: {
            visualization: {
              display_state: 'instructions',
              activity_state: 'opened'
            },
            model: {
              display_state: 'instructions',
              state: 'opened'
            },
            placeholder: {
              display_state: 'instructions',
              activity_state: 'opened',
              hide: _.without(allHideParams, 'instructions')
            }
          }
        }, {
          summary: {
            title: 'Results slide',
            description: 'Next, switch to the responses and review them as a class.'
          },
          activity: this.get('activity'),
          icon: McpResultsLockedIcon,
          states: {
            visualization: {
              display_state: 'chart',
              activity_state: 'closed'
            },
            model: {
              display_state: 'chart',
              state: 'closed'
            },
            placeholder: {
              display_state: 'chart',
              activity_state: 'closed',
              hide: _.without(allHideParams, 'instructions')
            }
          }
        }, {
          summary: {
            title: 'Correctness slide',
            description: 'Finish by revealing the correct response after anticipation builds.'
          },
          activity: this.get('activity'),
          icon: McpCorrectedLockedIcon,
          states: {
            visualization: {
              display_state: 'chart',
              activity_state: 'closed',
              display: 'correctness'
            },
            model: {
              display_state: 'chart',
              state: 'closed',
              flash_options: {
                display: 'correctness'
              }
            },
            placeholder: {
              display_state: 'chart',
              activity_state: 'closed',
              display: 'correctness',
              hide: _.without(allHideParams, 'instructions', 'correctness')
            }
          }
        }]))
        break

      case 'Engagement':
        this.set('steps', new Backbone.Collection([{
          summary: {
            title: 'Instructions slide',
            description: 'First, display instructions so everyone knows at a glance how to respond.'
          },
          activity: this.get('activity'),
          icon: McpOptionsIdealIcon,
          states: {
            visualization: {
              display_state: 'instructions',
              activity_state: 'opened'
            },
            model: {
              display_state: 'instructions',
              state: 'opened'
            },
            placeholder: {
              display_state: 'instructions',
              activity_state: 'opened',
              hide: _.without(allHideParams, 'instructions')
            }
          }
        }, {
          summary: {
            title: 'Results slide',
            description: 'Next, display live results and watch the charts come to life.'
          },
          activity: this.get('activity'),
          icon: McpResultsIdealIcon,
          states: {
            visualization: {
              display_state: 'chart',
              activity_state: 'opened'
            },
            model: {
              display_state: 'chart',
              state: 'opened'
            },
            placeholder: {
              display_state: 'chart',
              activity_state: 'opened',
              hide: allHideParams
            }
          }
        }, {
          summary: {
            title: 'Locked slide',
            description: 'Finally, lock the slide to prevent new responses.'
          },
          activity: this.get('activity'),
          icon: McpResultsLockedIcon,
          states: {
            visualization: {
              display_state: 'chart',
              activity_state: 'closed'
            },
            model: {
              display_state: 'chart',
              state: 'closed'
            },
            placeholder: {
              display_state: 'chart',
              activity_state: 'closed',
              hide: _.without(allHideParams, 'instructions')
            }
          }
        }]))
        break

      case 'Default':
        this.set('steps', new Backbone.Collection([{
          summary: {
            title: 'Results slide',
            description: 'The results slide activates this activity and shows responses.'
          },
          activity: this.get('activity'),
          icon: McpResultsIdealIcon,
          states: {
            visualization: {},
            model: {},
            placeholder: {
              hide: allHideParams
            }
          }
        }]))
        break
    }

    // Appending the name of the flow to the model state.
    // When flows are inserted into a deck, they become 3 separate slides.
    // We lose the understanding they are a part of the same entity. Until
    // we can come up with a better way to signal that, we're simply putting
    // a "marker" in a place that will make it to the URL when inserted.
    this.get('steps').forEach((step) => {
      step.get('states').model.flow = this.get('type')
    })
  }
}
